import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    goToTop: {
      borderRadius: '40px',
      background: 'var(--x-bg-8)',
      borderWidth: 0,
      width: 48,
      height: 48,
      '&:hover': {
        background: 'var(--x-bg-9)',
      },
    },
    goTopContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      zIndex: 100,
      position: 'sticky',
      bottom: 32,
      padding: [0, 24],
    },
  },
  {
    name: 'go-to-top-button',
  },
);

export default useStyles;
